import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/matter/query/', 'Matters');


// tbl.add(new Xtc('date', 'Matter'))
tbl.add(new Xtc('title', 'Title').renderSlot('title_matter'))
tbl.add(new Xtc('matter__client', 'Client').renderSlot('client'))
tbl.add(new Xtc('status', 'Status').renderSlot('status'))
tbl.add(new Xtc('practice_area.title', 'Practice Area'))
tbl.add(new Xtc('group.title', 'Group'))
tbl.add(new Xtc('open_date', 'Open date').hidden().renderSlot('open_date'))
tbl.add(new Xtc('closed_date', 'Closed date').hidden().renderSlot('close_date'))
tbl.add(new Xtc('limitation_date', 'Limitation date').hidden().renderSlot('limitation_date'))
tbl.add(new Xtc('reference_code', 'Reference Code'))
tbl.add(new Xtc('responsible.fullname', 'Responsible').renderSlot('responsible'))
tbl.add(new Xtc('origination.fullname', 'Origination').renderSlot('origination'))
tbl.add(new Xtc('location', 'Location').hidden())
// tbl.add(new Xtc('created_at', 'Created at').hidden())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

